module.exports = __webpack_public_path__ + "media/bootstrap-icons/dash-square-dotted-2a6e3505.svg";